module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "Home-Apply-O2.2f311441.jpeg" + "?" + Date.now();